module.exports = __webpack_public_path__ + "8428ea2270b791b4820ce5515b4e6562.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_folder.png
// module id = 7
// module chunks = 0 1 2 3 4